/**
 * @enum {enumSharableObjectType} Enumerated values for the type of objects that can be shared.
 * Example use case: Sharing a Channel (for collaboration between users)
 */
export enum enumSharableObjectType {
  Channel = 'Channel'
}
